"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMembersListByEmail = exports.updateExistingCustomMembersByEmail = exports.updateMemberIfEmailMatches = void 0;
const helpers_1 = require("@/app/shared/helpers");
/**
 * Find member by ID in array
 */
const findMemberById = (members, id) => {
    if (!id)
        return undefined;
    return members.find((m) => m.id === id);
};
/**
 * Find member by email in array
 */
const findMemberByEmail = (members, email) => {
    if (!email)
        return undefined;
    return members.find((m) => m.email && (0, helpers_1.isSameEmail)(m.email, email));
};
/**
 * Check if member with email exists as CUSTOM type
 */
const hasCustomMemberWithEmail = (members, email) => {
    if (!email)
        return false;
    return members.some((m) => m.type === "CUSTOM" /* MemberType.CUSTOM */ && m.email && (0, helpers_1.isSameEmail)(m.email, email));
};
/**
 * Replace single member with new one if email matches
 */
const updateMemberIfEmailMatches = (currentMember, newMembers) => {
    if (!currentMember?.email)
        return currentMember;
    return findMemberByEmail(newMembers, currentMember.email) ?? currentMember;
};
exports.updateMemberIfEmailMatches = updateMemberIfEmailMatches;
/**
 * Update single member by ID first, then by email for CUSTOM type
 */
const updateMemberByIdOrEmail = (currentMember, newMembers) => {
    // Priority 1: Match by ID
    const matchById = findMemberById(newMembers, currentMember.id);
    if (matchById)
        return matchById;
    // Priority 2: Match by email for CUSTOM only
    if (currentMember.type === "CUSTOM" /* MemberType.CUSTOM */) {
        return (0, exports.updateMemberIfEmailMatches)(currentMember, newMembers);
    }
    return currentMember;
};
/**
 * Update existing guests by email (does NOT add new members)
 * Used for guests reducer - updates existing CUSTOM members, doesn't add new ones
 */
const updateExistingCustomMembersByEmail = (currentMembers, newMembers) => {
    return currentMembers
        .map((current) => (current.type === "CUSTOM" /* MemberType.CUSTOM */ ? (0, exports.updateMemberIfEmailMatches)(current, newMembers) : current))
        .filter((m) => m !== null);
};
exports.updateExistingCustomMembersByEmail = updateExistingCustomMembersByEmail;
/**
 * Update membersData list by email and add new members
 * - Updates existing members by ID (if ID matches, replace with new data)
 * - Updates existing CUSTOM members by email
 * - Adds new members (deduplicates by ID, allows email duplicates with different IDs)
 */
const updateMembersListByEmail = (currentMembers, newMembers) => {
    // Step 1: Update existing members
    const updatedExisting = currentMembers
        .map((current) => updateMemberByIdOrEmail(current, newMembers))
        .filter((m) => m !== null);
    // Step 2: Add truly new members (deduplicated by ID)
    const existingIds = new Set(updatedExisting.map((m) => m.id).filter(Boolean));
    const trulyNewMembers = [];
    for (const newMember of newMembers) {
        // Skip if ID already exists
        if (newMember.id && existingIds.has(newMember.id))
            continue;
        // Skip if email matches existing CUSTOM member (already updated)
        if (hasCustomMemberWithEmail(currentMembers, newMember.email))
            continue;
        trulyNewMembers.push(newMember);
        if (newMember.id)
            existingIds.add(newMember.id);
    }
    return [...updatedExisting, ...trulyNewMembers];
};
exports.updateMembersListByEmail = updateMembersListByEmail;
